import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n';
import './BottomNavigation.css';

export const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const t = useTranslation();

  const navItems = [
    {
      id: 'home',
      title: t.nav.home,
      icon: '🏠',
      path: '/'
    },
    {
      id: 'meditations',
      title: t.nav.meditations,
      icon: '🧘',
      path: '/meditations'
    },
    {
      id: 'journal',
      title: t.nav.journal,
      icon: '📔',
      path: '/journal'
    },
    {
      id: 'tasks',
      title: t.nav.tasks,
      icon: '🎯',
      path: '/tasks'
    },
    {
      id: 'balance',
      title: t.nav.balance,
      icon: '💎',
      path: '/balance'
    },
    {
      id: 'profile',
      title: t.nav.profile,
      icon: '👤',
      path: '/profile'
    }
  ];

  const handleNavClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="bottom-navigation">
      <div className="nav-container">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleNavClick(item.path)}
          >
            <div className="nav-icon-emoji">{item.icon}</div>
            <span className="nav-title">{item.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
